export const environment = {
  production: true,
  hmr: false,
  logEverything: false,
  'TEST': '$(TEST)',
  API_URL: '$(API_URL)',
  APP_ENV: '$(APP_ENV)',
  APP_PATH: '$(APP_PATH)',
  mfaEnabled: '$(MFA_ENABLED)'.indexOf('true') === 0,
  mssoEnabled: true, // it is using in CI job only
  rpid: '$(RPID)',
  mssoLoginPost: '$(MSSO_POST)',
  mssoFailureUrl: '$(MSSO_FAILURE)',
  API: '$(API)',
  appName: '$(APP_NAME)',
  clientUrl: '$(CLIENT_URL)',
  appUrl: '$(CLIENT_URL)',
  internal: false,
  banner: '$(BANNER_MSG)',
  version: '$(BANNER_VERSION)',
  showBanner: '$(SHOW_BANNER)',
  pendoKey: '$(PENDO_KEY)',
  pendoEnabled: '$(PENDO_ENABLED)',
  mfaSupportEmail: '$(MFA_SUPPORT_EMAIL)',
  copyrightYear: '$(COPYRIGHT_YEAR)',
  micEnabled: '$(MIC_ENABLED)',
  jwtTokenExpiresIn: '$(JWT_TOKEN_EXPIRES_IN)',
  refreshTokenExpiresIn: '$(REFRESH_TOKEN_EXPIRES_IN)',
  devLoginEnabled: '$(DEV_LOGIN_ENABLED)',
  importantNoticeEnabled: '$(IMPORTANT_NOTICE_ENABLED)'.startsWith('true')
};
